<template>
  <div class="px-2 grey lighten-3">
    <!--       <keep-alive>
            <router-view :key="$route.meta.componentName"></router-view>
      </keep-alive> -->
    <router-view :key="$route.meta.componentName" />
  </div>
</template>

<script>
export default {
  name: 'MasterLayout',
  data () {
    return { loaded: false };
  }
};
</script>

<style lang="scss">
#customers-content {
  height: calc(100vh - 117px);
  overflow-y: auto;
}

</style>
